import CommonAppStarter from '@src/page/toc/slide-edit/common-app-starter';
import { PcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import NoEditModules from '@src/slide/application/no-edit/entry/toc/editor/pc';

export default class TocAppStarter extends CommonAppStarter {
    protected initAppServices() {
        const appServices = new PcEditorAppServices();
        AppServiceProvider.getInstance().initWithAppServices(appServices);

        new NoEditModules().init(appServices.viewableServiceLayer.extensionService);
    }
}
